import React from "react";
import { Route } from "react-router-dom";
import MainLayout from "../../components/MainLayout/MainLayout";
import { AuthenticationGuard } from "@/components/AuthenticationGuard/AuthenticationGuard";
import CatalogPage from "@/modules/hub/features/ProductCatalog/components/CatalogPage/CatalogPage";
import ProductLandingPage from "@/modules/hub/features/ProductCatalog/components/ProductLandingPage/ProductLandingPage";

const CatalogLayout = () => <MainLayout section="hub" />;

// Auth-only like the other member-facing hub pages (Lead Generation,
// Growth Stages) — visibility is handled by the nav item's not-yet-GA gate.
const CatalogRoutes = (
  <Route
    element={<AuthenticationGuard component={CatalogLayout} />}
    path="/catalog"
  >
    <Route element={<CatalogPage />} index />
    <Route element={<ProductLandingPage />} path=":slug" />
  </Route>
);

export default CatalogRoutes;
